export const TRACE_LOG_INFO_LEVEL = {
  TURN: 0,
  NODE: 1,
  NODE_STATE: 2,
  NODE_STATE_EXPANDED: 3,
} as const;

// This creates a type for the values
export type TraceLogInfoLevel =
  (typeof TRACE_LOG_INFO_LEVEL)[keyof typeof TRACE_LOG_INFO_LEVEL];
